const widgetStates = {
  slots: 'slots',
  inputs: 'inputs',
  success: 'success',
};

export default widgetStates;
